import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';

const CallexLoader = ({ width, height }) => {
  return (
    <div className="loader-container">
      <Spinner
        className="spinner"
        style={{
          width: width || '2    rem',
          height: height || '2  rem'
        }}
      />
    </div>
  );
};

CallexLoader.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
};

export default CallexLoader;
